'use client';

import { LoggerInterface } from '@coolblue-development/logging-abstraction';

import { applicationFormSelector } from '../ApplicationForm/Form';

const calculateTopPositionOfTargetBlock = (targetBlock: Element): number => {
  const headerHeight = 52;
  const padding = 32;
  const headerOffset = headerHeight + padding;
  const targetBlockPosition = targetBlock.getBoundingClientRect().top;

  return targetBlockPosition + window.scrollY - headerOffset;
};

export const handleToBlockCallToAction = async (logger: LoggerInterface): Promise<void> => {
  const targetBlockElement = document.querySelector(`#${applicationFormSelector}`);
  if (!targetBlockElement) {
    await logger.error(
      'Could not handle call to action to a block',
      new Error(`Element with id ${applicationFormSelector} was not found`)
    );

    return;
  }

  window.scrollTo({
    top: calculateTopPositionOfTargetBlock(targetBlockElement),
    behavior: 'smooth'
  });
};
